import React from 'react';
import PropTypes from 'prop-types';
import Article from './Article';
import MediaCarousel from './MediaCarousel';
import LogoCarousel from './LogoCarousel';
import NewsCarousel from './NewsCarousel';
import HowToComponent from './HowTo';
import { Container } from '../../gridSystem';
import CategoryCarousel from './CategoryCarousel';
import Statistics from './Statistics';
import Timeline from './Timeline';

const PublicPageComponent = ({
  type,
  data,
  title,
  body,
  background,
  firstArticle,
}) => {
  switch (type) {
    case PublicPageComponent.TYPES.ARTICLE:
      return <Article data={data?.data} firstArticle={firstArticle} />;
    case PublicPageComponent.TYPES.MEDIA:
      return (
        <Container className="pt-0">
          <MediaCarousel data={data} title={title} />
        </Container>
      );
    case PublicPageComponent.TYPES.LOGO:
      return (
        <LogoCarousel
          data={data}
          title={title}
          body={body}
          background={background}
        />
      );
    case PublicPageComponent.TYPES.NEWS:
      return <NewsCarousel data={data} title={title} />;
    case PublicPageComponent.TYPES.HOWTO:
      return (
        <Container className="pt-0">
          <HowToComponent data={data} title={title} body={body} />
        </Container>
      );
    case PublicPageComponent.TYPES.STATISTICS:
      return <Statistics data={data} background={background} />;
    case PublicPageComponent.TYPES.CATEGORIES:
      return <CategoryCarousel data={data} title={title} body={body} />;
    case PublicPageComponent.TYPES.TIMELINE:
      return (
        <Container className="pt-0">
          <Timeline data={data} title={title} body={body} />
        </Container>
      );

    default:
      return null;
  }
};

PublicPageComponent.TYPES = {
  MEDIA: 'media_carousel',
  LOGO: 'logo_carousel',
  NEWS: 'news_carousel',
  ARTICLE: 'content_element',
  HOWTO: 'how_to_carousel',
  STATISTICS: 'statistics_item',
  CATEGORIES: 'taxonomy_carousel',
  TIMELINE: 'timeline_carousel',
};

PublicPageComponent.propTypes = {
  type: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  body: PropTypes.string,
  background: PropTypes.string,
  firstArticle: PropTypes.bool,
};

export default PublicPageComponent;
